<template>
  <div class="common_foot">
	<footer>
		<div class="container">
			<div class="row">
				<div class="col-lg-3">
					<div class="about">
						<div class="logo"><a href="index.html">{{ common_platform_data.platformName }}<em>.</em></a></div>
						<p>{{ common_platform_data.platformAdvertisement}}.</p>
					</div>
				</div>
				<div class="col-lg-3">
					<h4>公司信息</h4>
					<ul class="list">
						<li><a ><i class="fa fa-envelope"></i> 企业邮箱：{{ common_platform_data.compEmail }}</a></li>
						<li><a :href="'tel:'+common_platform_data.compTell"><i class="fa fa-phone"></i> 客服电话：{{ common_platform_data.compTell }}</a></li>
						<li><a href="tel:4001811810"><i class="fa fa-phone"></i> 售后电话：400-181-1810</a></li>
            <li><a ><i class="fa fa-map-marker"></i> 公司地址： {{ common_platform_data.compAddress }}.</a></li>
					</ul>
				</div>
				<div class="col-lg-3">
					<h4>快捷链接</h4>
					<ul class="list">
						<li><a href="#" @click.prevent="$router.push('comp_index');gotoTop()" >> 公司简介</a></li>
						<li><a href="#" @click.prevent="$router.push('goodsType');gotoTop()" >> 产品大全</a></li>
						<li><a href="#" @click.prevent="$router.push('caseIndex');gotoTop()" >> 成功案例</a></li>
						<li><a href="#" @click.prevent="$router.push('concatsus');gotoTop()" >> 在线留言</a></li>
					</ul>
				</div>
				<div class="col-lg-3">
					<h4>官方账号</h4>
<!--					<ul class="social-icons">-->
<!--						<li  title="客服微信"><a class="foot_icon_li" href="https://facebook.com" target="_blank"><svg t="1724641855068" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4406" width="25" height="25"><path d="M824.8 613.2c-16-51.4-34.4-94.6-62.7-165.3C766.5 262.2 689.3 112 511.5 112 331.7 112 256.2 265.2 261 447.9c-28.4 70.8-46.7 113.7-62.7 165.3-34 109.5-23 154.8-14.6 155.8 18 2.2 70.1-82.4 70.1-82.4 0 49 25.2 112.9 79.8 159-26.4 8.1-85.7 29.9-71.6 53.8 11.4 19.3 196.2 12.3 249.5 6.3 53.3 6 238.1 13 249.5-6.3 14.1-23.8-45.3-45.7-71.6-53.8 54.6-46.2 79.8-110.1 79.8-159 0 0 52.1 84.6 70.1 82.4 8.5-1.1 19.5-46.4-14.5-155.8z" p-id="4407" fill="#2c2c2c"></path></svg></a></li>-->
<!--						<li  title="客服QQ"><a class="foot_icon_li" href="https://twitter.com" target="_blank"><svg t="1724641880411" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5513" width="25" height="25"><path d="M664.250054 368.541681c10.015098 0 19.892049 0.732687 29.67281 1.795902-26.647917-122.810047-159.358451-214.077703-310.826188-214.077703-169.353083 0-308.085774 114.232694-308.085774 259.274068 0 83.708494 46.165436 152.460344 123.281791 205.78483l-30.80868 91.730191 107.688651-53.455469c38.558178 7.53665 69.459978 15.308661 107.924012 15.308661 9.66308 0 19.230993-0.470721 28.752858-1.225921-6.025227-20.36584-9.521864-41.723264-9.521864-63.862493C402.328693 476.632491 517.908058 368.541681 664.250054 368.541681zM498.62897 285.87389c23.200398 0 38.557154 15.120372 38.557154 38.061874 0 22.846334-15.356756 38.156018-38.557154 38.156018-23.107277 0-46.260603-15.309684-46.260603-38.156018C452.368366 300.994262 475.522716 285.87389 498.62897 285.87389zM283.016307 362.090758c-23.107277 0-46.402843-15.309684-46.402843-38.156018 0-22.941502 23.295566-38.061874 46.402843-38.061874 23.081695 0 38.46301 15.120372 38.46301 38.061874C321.479317 346.782098 306.098002 362.090758 283.016307 362.090758zM945.448458 606.151333c0-121.888048-123.258255-221.236753-261.683954-221.236753-146.57838 0-262.015505 99.348706-262.015505 221.236753 0 122.06508 115.437126 221.200938 262.015505 221.200938 30.66644 0 61.617359-7.609305 92.423993-15.262612l84.513836 45.786813-23.178909-76.17082C899.379213 735.776599 945.448458 674.90216 945.448458 606.151333zM598.803483 567.994292c-15.332197 0-30.807656-15.096836-30.807656-30.501688 0-15.190981 15.47546-30.477129 30.807656-30.477129 23.295566 0 38.558178 15.286148 38.558178 30.477129C637.361661 552.897456 622.099049 567.994292 598.803483 567.994292zM768.25071 567.994292c-15.213493 0-30.594809-15.096836-30.594809-30.501688 0-15.190981 15.381315-30.477129 30.594809-30.477129 23.107277 0 38.558178 15.286148 38.558178 30.477129C806.808888 552.897456 791.357987 567.994292 768.25071 567.994292z" fill="#2c2c2c" p-id="5514"></path></svg></a></li>-->
<!--          </ul>-->
          <div class="social-div">
            <img v-if="common_platform_data.compSWchatRcode" title="客服微信" :src="common_platform_data.compSWchatRcode" />
            <img v-if="common_platform_data.compWgzhRcode" title="公众号" :src="common_platform_data.compWgzhRcode" />
          </div>
				</div>
			</div>
		</div>
	</footer>

	<div class="sub-footer">
		<div class="container">
			<div class="row">
				<div class="col-lg-12">
					<p>Copyright @
            {{ common_platform_data.icpYear }}
            {{ common_platform_data.compName }}.
            备案号：<a target="_blank" href="https://beian.miit.gov.cn/">{{ common_platform_data.icpCode }}</a>
          </p>
				</div>
			</div>
		</div>
	</div>
  </div>
</template>

<!-- 组件js部分 -->
<script>
export default {
  name: 'common_foot',
  data () {
    return {
      common_platform_data:{
        "id": null,
        "createBy": null,
        "createTime": null,
        "updateBy": null,
        "updateTime": null,
        "sysOrgCode": null,
        "platformName": null,
        "platformAdvertisement": null,
        "compName": null,
        "compEmail": null,
        "compTell": null,
        "compAddress": null,
        "compAddressLat": null,
        "compAddressLong": null,
        "compJoinTell": null,
        "compSQq": null,
        "compSWchat": null,
        "compWgzhRcode": null,
        "compSWchatRcode": null,
        "icpName": null,
        "icpHost": null,
        "icpYear": null,
        "icpCode": null
      }
    }
  },
  created() {
    this.getCompInfoData();
  },
  methods:{
    gotoTop(){
      setTimeout(function(){
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      },500);

    },
    // 查询公司以及平台信息
    getCompInfoData(){
      let _this = this;
      this.$axios.get('/fantis/compdata/ftComp/queryById?id=101')
        .then(function(res){ // 请求成功 HTTP状态码是200
          if(res.data.code == 200){
            var tempData = res.data.result;
            _this.common_platform_data = res.data.result;
            if(_this.common_platform_data.compWgzhRcode!=null && _this.common_platform_data.compWgzhRcode!=""){
              _this.common_platform_data.compWgzhRcode =
                _this.$fileDPath + _this.common_platform_data.compWgzhRcode;
            }
            if(_this.common_platform_data.compSWchatRcode!=null && _this.common_platform_data.compSWchatRcode!=""){
              _this.common_platform_data.compSWchatRcode =
                _this.$fileDPath + _this.common_platform_data.compSWchatRcode;
            }
          }else{
            _this.$message.error(res.data.msg);
          }
        })
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    }
  },
  watch:{

  }
}
</script>

<style scoped>
.foot_icon_li{
  display: flex;
  justify-content: center;
  align-items: center;
}

.social-div{
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-div>img{
  width: 50%;
  margin-left: 10px;
  margin-top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/common_foot.vue